import Vue from "vue";
import VueRouter from "vue-router";
import WhyHomePage from "@/views/WhyHomePage";
import WhyAboutPage from "@/views/WhyAboutPage";
import WhyServicesPage from "@/views/WhyServicesPage";
import WhyCasesPage from "@/views/WhyCasesPage";
import WhyContactPage from "@/views/WhyContactPage";
import WhyPrivacyPage from "@/views/WhyPrivacyPage";
import WhySupportPage from "@/views/WhySupportPage";
import WhyTermsPage from "@/views/WhyTermsPage";
import WhySiteMapPage from "@/views/WhySiteMapPage";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "why-home",
        component: WhyHomePage,
        meta: { title: "闲农日季 - 专业美容美体连锁机构" },
    },
    {
        path: "/about",
        name: "why-about",
        component: WhyAboutPage,
        meta: { title: "关于我们 - 闲农日季" },
    },
    {
        path: "/services",
        name: "why-services",
        component: WhyServicesPage,
        meta: { title: "服务项目 - 闲农日季" },
    },
    {
        path: "/cases",
        name: "why-cases",
        component: WhyCasesPage,
        meta: { title: "案例展示 - 闲农日季" },
    },
    {
        path: "/contact",
        name: "why-contact",
        component: WhyContactPage,
        meta: { title: "联系我们 - 闲农日季" },
    },
    {
        path: "/privacy",
        name: "why-privacy",
        component: WhyPrivacyPage,
        meta: {
            title: "隐私政策 - 闲农日季",
        },
    },
    {
        path: "/support",
        name: "why-support",
        component: WhySupportPage,
        meta: {
            title: "技术支持中心 - 闲农日季",
        },
    },
    {
        path: "/terms",
        name: "why-terms",
        component: WhyTermsPage,
        meta: {
            title: "服务条款 - 闲农日季",
        },
    },
    {
        path: "/sitemap",
        name: "why-sitemap",
        component: WhySiteMapPage,
        meta: {
            title: "网站地图 - 闲农日季",
        },
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "闲农日季";
    next();
});

export default router;
